export const ATRIAL_FIBRILLATION_EVENT_TYPE = 'atrial_fibrillation';
export const ATRIAL_FIBRILLATION_X_EVENT_TYPE = 'atrial_fibrillation_x';

export function isAtrialFibrillationXEvent(eventType: string): boolean {
  const t = (eventType || '').toLowerCase().trim();
  return t === ATRIAL_FIBRILLATION_X_EVENT_TYPE || t.startsWith(`${ATRIAL_FIBRILLATION_X_EVENT_TYPE}_`);
}

export function isAtrialFibrillationEvent(eventType: string): boolean {
  const t = (eventType || '').toLowerCase().trim();
  return t === ATRIAL_FIBRILLATION_EVENT_TYPE || t.startsWith('atrial_fibrillation_');
}

/** Distinct filter keys for base AF vs AF X in the event-type filter UI. */
export function normalizeAtrialFibrillationEventTypeForUi(eventType: string): string {
  if (isAtrialFibrillationXEvent(eventType)) return ATRIAL_FIBRILLATION_X_EVENT_TYPE;
  if (isAtrialFibrillationEvent(eventType)) return ATRIAL_FIBRILLATION_EVENT_TYPE;
  return (eventType || '').toLowerCase().trim();
}

/** UI label; includes suffix from types like atrial_fibrillation_X when present in DB. */
export function getAtrialFibrillationDisplayLabel(eventType: string): string {
  const raw = (eventType || '').trim();
  const match = raw.match(/^atrial_fibrillation_(.+)$/i);
  if (match) {
    const suffixDisplay = match[1]
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (l) => l.toUpperCase());
    return `Atrial Fibrillation ${suffixDisplay}`;
  }
  return 'Atrial Fibrillation';
}
